import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, Link } from "react-router-dom";
import { categoryActions } from "@/_actions/category.actions";
import { useDispatch, useSelector } from "react-redux";

function Sitemap() {
  const { t } = useTranslation();
  let location = useLocation();
  const dispatch = useDispatch();
  const { categories, isLoading, error } = useSelector(state => state?.category);

  useEffect(() => {
        dispatch(categoryActions.getCategories());
    }, [dispatch]);

  return (
    <div className="InternalPage">
      <section className="InternalBody">
        <div className="sitemap-wrapper">
          <div className="row-wrap">
            <div className="sitemap-header">Main Pages</div>

            <div className="column">
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">About yslearn.in</Link>
                </li>
                <li>
                  <Link to="/teachers">Getting started for Instructors</Link>
                </li>
              </ul>
            </div>

            <div className="column">
              <ul>
                <li>
                  <Link
                    to={{
                      pathname: "/register",
                      state: "teacher",
                      comeFrom:
                        location?.state?.comeFrom === "/teachers"
                          ? true
                          : false,
                    }}
                  >
                    Be an Instructor
                  </Link>
                </li>
                <li>
                  <a href={"mailto: support@yslearn.in.com"}>Get in Touch</a>
                </li>
                <li>
                  <Link to="/register">Getting started for Students</Link>
                </li>
              </ul>
            </div>

            <div className="column">
              <ul>
                <li>
                  <Link to="/business">yslearn.in Enterprise</Link>
                </li>
                <li>
                  <Link to="/pricing">Frequently Asked Questions (FAQs)</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="row-wrap">
            <div className="sitemap-header">Product Pages</div>

            <div className="column">
              <ul>
                <li>
                  <Link to="/business">yslearn.in Enterprise</Link>
                </li>
                <li>
                  <Link to="/pricing">
                    yslearn.in for Universities, Colleges &amp; Institutes
                  </Link>
                </li>
                <li>
                  <Link to="/pricing">yslearn.in for Corporate Training</Link>
                </li>
              </ul>
            </div>

            <div className="column">
              <ul>
                <li>
                  <a href={"mailto: support@yslearn.in.com"}>
                    White Label/Custom Solutions
                  </a>
                </li>
                <li>
                  <Link to="/business">Enterprise Features</Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="row-wrap">
            <div className="sitemap-header">Category and Catalogue</div>
            {categories?.map((category, index) => {
              return (
                <div className="column" key={index}>
                  <ul>
                    <li>
                      {" "}
                      <Link
                        to={{
                          pathname: "/courses",
                          state: {
                            category: category.categoryName,
                          },
                        }}
                      >
                        {category.categoryName}
                      </Link>
                    </li>
                  </ul>
                </div>
              );
            })}
          </div>
          <div className="row-wrap">
            <div className="sitemap-header">Legals</div>

            <div className="column">
              <ul>
                <li>
                  <Link to="/terms">Terms &amp; Conditions</Link>
                </li>
                <li>
                  <Link to="/privacy">Privacy Policy</Link>
                </li>
              </ul>
            </div>

            {/*
                        <div className='column'>
                            <ul>
                                <li>
                                    <a href='please-enter-url'>White Papers</a>
                                </li>
                                <li>
                                    <a href='please-enter-url'>
                                        Missing something
                                    </a>
                                </li>
                                <li>
                                    <a href='please-enter-url'>
                                        Missing something
                                    </a>
                                </li>
                            </ul>
                        </div>

                        
                        <div className='column'>
                            <ul>
                                <li>
                                    <a href='please-enter-url'>
                                        Guides & Tutorials
                                    </a>
                                </li>
                                <li>
                                    <a href='please-enter-url'>Changelogs</a>
                                </li>
                                <li>
                                    <a href='please-enter-url'>
                                        Missing something
                                    </a>
                                </li>
                            </ul>
                        </div>
                        */}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Sitemap;
